export const flexCentre = () => `
  display: flex;
  align-items: center;
  justify-content: center;
`;
